module.exports = __webpack_public_path__ + "img/logo_company.0af10bd3.png";